/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ vam: NonNullable<unknown> }} Ui_Rail_Vam_AvgInputs */

const en_ui_rail_vam_avg = /** @type {(inputs: Ui_Rail_Vam_AvgInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`↗ Ø ${i?.vam} m/h`)
};

const de_ui_rail_vam_avg = /** @type {(inputs: Ui_Rail_Vam_AvgInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`↗ Ø ${i?.vam} m/h`)
};

/**
* | output |
* | --- |
* | "↗ Ø {vam} m/h" |
*
* @param {Ui_Rail_Vam_AvgInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_rail_vam_avg = /** @type {((inputs: Ui_Rail_Vam_AvgInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Rail_Vam_AvgInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_rail_vam_avg(inputs)
	return de_ui_rail_vam_avg(inputs)
});